import { START_BOUNDED_ID_SCHEMA, START_TRIMMED_NON_EMPTY_STRING_SCHEMA } from "./shared.js";
import { wakeLoopProfileIdSchema } from "../daemon/profile-identity.js";
import { z } from "zod/v4";
//#region src/schemas/start/onboarding-plan.ts
const onboardingActionIdSchema = z.enum([
	"sign_in",
	"set_display_name",
	"enter_space",
	"bring_agents",
	"connect_this_computer"
]);
const onboardingDecisionStatusSchema = z.enum([
	"done",
	"available",
	"blocked"
]);
const onboardingReasonCodeSchema = z.enum([
	"auth.signed_out",
	"auth.signed_in",
	"identity.name_missing",
	"identity.name_present",
	"space.none_in_context",
	"space.not_joined",
	"space.joined",
	"agents.none_yet",
	"agents.addable_present",
	"agents.member_present",
	"computer.connected",
	"computer.connecting",
	"computer.not_connected",
	"computer.evidence_unavailable"
]);
const onboardingPlanDecisionSchema = z.strictObject({
	id: onboardingActionIdSchema,
	status: onboardingDecisionStatusSchema,
	blocking: z.boolean(),
	reason: onboardingReasonCodeSchema,
	run: z.union([START_TRIMMED_NON_EMPTY_STRING_SCHEMA, z.null()]),
	afterRun: z.union([START_TRIMMED_NON_EMPTY_STRING_SCHEMA, z.null()])
});
const onboardingPlanSummarySchema = z.enum(["nothing_to_do", "actions_pending"]);
const onboardingPlanSchema = z.strictObject({
	decisions: z.array(onboardingPlanDecisionSchema).readonly(),
	summary: onboardingPlanSummarySchema
});
const onboardingProfileKindSchema = z.enum(["human", "agent"]);
const onboardingAccountProfileSchema = z.strictObject({
	profileId: wakeLoopProfileIdSchema,
	kind: onboardingProfileKindSchema,
	name: START_TRIMMED_NON_EMPTY_STRING_SCHEMA,
	active: z.boolean()
});
const onboardingAuthFactSchema = z.discriminatedUnion("signedIn", [z.strictObject({
	signedIn: z.literal(true),
	userId: START_BOUNDED_ID_SCHEMA,
	actingProfileId: wakeLoopProfileIdSchema,
	actingDisplayName: z.union([START_TRIMMED_NON_EMPTY_STRING_SCHEMA, z.null()])
}), z.strictObject({ signedIn: z.literal(false) })]);
const onboardingSpaceContextSchema = z.union([z.strictObject({
	spaceId: START_BOUNDED_ID_SCHEMA,
	actingProfileIsMember: z.boolean(),
	memberAgentProfileIds: z.array(wakeLoopProfileIdSchema).readonly()
}), z.null()]);
const onboardingDeviceStatusSchema = z.enum([
	"connected",
	"connecting",
	"not_connected",
	"unknown"
]);
const onboardingDeviceFactSchema = z.strictObject({ status: onboardingDeviceStatusSchema });
const onboardingContextSlotSchema = z.discriminatedUnion("kind", [z.strictObject({ kind: z.literal("none") }), z.strictObject({
	kind: z.literal("web_setup_handoff"),
	startSessionToken: START_BOUNDED_ID_SCHEMA
})]);
const onboardingFactsSchema = z.strictObject({
	auth: onboardingAuthFactSchema,
	accountProfiles: z.array(onboardingAccountProfileSchema).readonly(),
	space: onboardingSpaceContextSchema,
	device: onboardingDeviceFactSchema,
	context: onboardingContextSlotSchema
}).superRefine((value, ctx) => {
	const seenProfileIds = /* @__PURE__ */ new Set();
	for (const [index, profile] of value.accountProfiles.entries()) {
		if (seenProfileIds.has(profile.profileId)) {
			ctx.addIssue({
				code: "custom",
				message: "accountProfiles must not contain duplicate profileId values",
				path: [
					"accountProfiles",
					index,
					"profileId"
				]
			});
			continue;
		}
		seenProfileIds.add(profile.profileId);
	}
});
//#endregion
export { onboardingAccountProfileSchema, onboardingActionIdSchema, onboardingAuthFactSchema, onboardingContextSlotSchema, onboardingDecisionStatusSchema, onboardingDeviceFactSchema, onboardingDeviceStatusSchema, onboardingFactsSchema, onboardingPlanDecisionSchema, onboardingPlanSchema, onboardingPlanSummarySchema, onboardingProfileKindSchema, onboardingReasonCodeSchema, onboardingSpaceContextSchema };

//# sourceMappingURL=onboarding-plan.js.map